import axios from 'axios'
//import { refreshMsalIdToken } from '../auth';
import { getToken } from '../auth/auth.service'
import { envConfig } from '../config/envConfig'
// import { convertDatesToDDMMYYYY } from '../helpers/formatDateOnly'
import { ApiError } from '../model/apiError'
import { AppConfigurationKey } from '../model/enums/appConfigurationKey'
import { AppSubscriptionKey } from '../model/enums/appSubscriptionKey'
import { getAppConfigurationValue, notifyError, setIsLoading } from '../redux'
import { cancelTokenSource } from './Pioneer/endpoints/trades/trades.api'

let AxiosInstance = axios.create({
  timeout: 30000
})

// Estados de respuesta que consideramos validos
AxiosInstance.defaults.validateStatus = (status: number) => {
  return (status >= 200 && status < 300) || status === 498
}

AxiosInstance.interceptors.request.use(
  async config => {
    if (getAppConfigurationValue(AppConfigurationKey.Host) !== undefined) {
      config.baseURL = getAppConfigurationValue(AppConfigurationKey.Host)
    }
    setIsLoading(true)

    config.headers['Ocp-Apim-Subscription-Key'] =
      getAppConfigurationValue(AppSubscriptionKey.FrontSubscription) ??
      envConfig.subscriptions.front

    config.headers['Authorization'] = `Bearer ${await getToken()}`

    // Conversión de fechas antes de enviar la request - para los casos en los que se envíen fechas tipo Date
    // Se convierte a string DD/MM/YYYY
    // Solo convierte fechas si el método es POST o PATCH
    // el codigo funciona pero queda comentado por ahora
    // if (config.data && config.method && ['post', 'patch'].includes(config.method.toLowerCase())) {
    //   config.data = convertDatesToDDMMYYYY(config.data)
    // }

    // se comenta ya que jwt con Bearer Token protege contra CSRF
    // if (config.url?.includes('globalsyde.com') || envConfig.environment === 'development') {
    //   config.withCredentials = true

    //   const xsrfToken = document.cookie
    //     ?.split('; ')
    //     .find(row => row.startsWith('XSRF-TOKEN='))
    //     ?.split('=')[1]

    //   config.headers['X-XSRF-TOKEN'] = xsrfToken
    // }

    return config
  },
  error => {
    setIsLoading(false)
    return Promise.reject(error)
  }
)

AxiosInstance.interceptors.response.use(
  response => {
    setIsLoading(false)
    return response
  },
  error => {
    // console.log(JSON.stringify(error))
    const unescapedString =
      error.response?.data?.messages?.length > 0
        ? error.response.data.messages[0].replace(/\\r/g, '\\r').replace(/\\n/g, '\\n')
        : null
    const errorMs =
      typeof unescapedString === 'string' ? unescapedString : JSON.parse(unescapedString)
    setIsLoading(false)

    if (error.code === 'ECONNABORTED') {
      // TODO: i18n
      cancelTokenSource && cancelTokenSource()
      notifyError('Se ha perdido la conexion con el servidor (timeout)')
    } else if (error.response?.status === 412) {
      // Rulebook errors
      console.log('ERROR 412', error.response)
      return Promise.reject({
        statusCode: error.response.status,
        errors:
          error.response.data.value !== undefined
            ? error.response.data.value.map(x => x.errorCode)
            : error.response.data.messages !== undefined
              ? error.response.data.messages
              : error.response.data.map(x => x.errorCode)
      } as ApiError)
    } else if (errorMs?.messages && errorMs.messages.length > 0 && +errorMs.messages[0] > 0) {
      // console.log(errorMs.messages[1])
      return Promise.reject({
        id: errorMs.messages.length > 1 ? errorMs.messages[1] : null,
        statusCode: 412,
        errors: [errorMs.messages[0]]
      } as ApiError)
    } else if (errorMs?.error?.details && errorMs.error.details.length > 0) {
      const errorCode =
        errorMs.error.details[0].target && errorMs.error.details[0].target.length > 0
          ? errorMs.error.details[0].target
          : ''

      return Promise.reject({
        statusCode: 412,
        errors: [errorCode]
      } as ApiError)
    } else {
      console.log('ERROR interceptor', error.response, {
        statusCode: error.response.status,
        errors: [error.response ? error.response.statusText : '']
      })

      const rawData = error.response?.data
      const plainStringError = typeof rawData === 'string' && rawData.length > 0 ? rawData : null

      return Promise.reject({
        statusCode: error.response.status,
        errors: plainStringError
          ? [plainStringError]
          : typeof unescapedString === 'string'
            ? [errorMs]
            : null
      } as ApiError)
    }
    return Promise.reject(error)
  }
)

export default AxiosInstance
